module.exports = __webpack_public_path__ + "img/2023-12_commencement.2eb8ba6a.jpg";